import BodyText from 'components/Luxkit/Typography/BodyText'
import React, { useContext } from 'react'
import Group from 'components/utils/Group'
import { TrustIndicatorUK } from 'home/components/UspBanner/TrustIndicatorUK'
import { getSVGImageUrl } from 'lib/imageUtils'
import { TrustPilotLogoSmall, FacebookLogo } from '../../common'
import GeoContext from 'contexts/geoContext'

interface Props {
  hideFacebook: boolean;
}

export function TrustIndicatorsMapper({ hideFacebook }: Props) {
  const { currentRegionCode } = useContext(GeoContext)
  const isUK = currentRegionCode === 'GB'

  return (
    <Group direction="horizontal" verticalAlign="center" gap={24} horizontalAlign={(hideFacebook && !isUK) ? 'start' : 'center'}>
      {!isUK && (
        <>
          <Group gap={8} direction="horizontal" verticalAlign="start">
            <TrustPilotLogoSmall />
            <BodyText weight="bold" variant="large" wrap="no-wrap">Trustpilot · 4.8/5</BodyText>
          </Group>
          {!hideFacebook && (
            <Group gap={8} direction="horizontal" verticalAlign="center">
              <FacebookLogo />
              <BodyText weight="bold" variant="large" align="center" wrap="no-wrap">1,484,233 followers</BodyText>
            </Group>
          )}
        </>
      )}
      {isUK && hideFacebook && (
        <>
          <Group gap={8} direction="horizontal" verticalAlign="start">
            <img src={getSVGImageUrl('984lj4elpskyg828z90qb')} width="20" height="20" alt=""/>
            <BodyText weight="bold" variant="large" wrap="no-wrap">ATOL protected</BodyText>
          </Group>
          <Group gap={8} direction="horizontal" verticalAlign="start">
            <TrustPilotLogoSmall />
            <BodyText weight="bold" variant="large" wrap="no-wrap">Trustpilot · 4.8/5</BodyText>
          </Group>
        </>
      )}
      {isUK && !hideFacebook && (
        <TrustIndicatorUK isLoginStartModalExperiment />
      )}
    </Group>
  )
}
